import axios from "axios";

const getCountries = async () => {
  const response = await axios.get('https://countriesnow.space/api/v0.1/countries/capital');
  return response.data;
};

const getStatesByCountry = async (country) => {
  const response = await axios.post('https://countriesnow.space/api/v0.1/countries/states', {country: country});
  console.log(response);
  return response.data;
};

const getCitiesByCountry = async (data) => {
  const response = await axios.post('https://countriesnow.space/api/v0.1/countries/state/cities', {...data});
  console.log(response);
  return response.data;
};


const countryService = {
  getCountries ,
  getStatesByCountry,
  getCitiesByCountry
};

export default countryService